/**
 * Greyed "Add another policy" — the second compounding axis, shown closed.
 *
 * The launch contract is pinned to one policy group. The affordance is visible
 * and disabled so an AM can see the shape without a second policy launching.
 */

export const CLOSED_POLICY_GATE_REASON =
  "The second axis — N policies per run, each with its own term and actions.";

export default function AddPolicyAffordance(_props: { disabled?: boolean } = {}) {
  return (
    <div className="flex flex-col gap-1" data-testid="launch-add-policy-affordance">
      <button
        type="button"
        disabled
        aria-describedby="launch-add-policy-reason"
        className="flex touch-target w-full items-center justify-center gap-2 rounded-lg border border-dashed border-primary-gray-light-200 bg-primary-gray-light-50 px-3 py-2.5 text-xs font-medium text-primary-gray-light-400"
        data-testid="launch-add-policy"
      >
        <span aria-hidden="true">+</span>
        Add another policy
      </button>
      <p
        id="launch-add-policy-reason"
        className="text-2xs leading-snug text-primary-gray-light-400"
        data-testid="launch-add-policy-reason"
      >
        {CLOSED_POLICY_GATE_REASON}
      </p>
    </div>
  );
}
